export enum LocalStorageKeys {
  ORDER_HISTORY = "ORDER_HISTORY",
}

export enum OrderMode {
  DINEIN = "DINE IN",
  TAKEAWAY = "TAKE AWAY",
}

export enum EnumTypes {
  ITEM_SIZE = "ITEM_SIZE",
  PAYMENT_MODE = "PAYMENT_MODE",
  ORDER_SOURCE = "ORDER_SOURCE",
  DISCOUNT_UNIT = "DISCOUNT_UNIT",
  ITEM_CATEGORIES = "ITEM_CATEGORIES",
  EXPIRY_CONFIG = "EXPIRY_CONFIG",
  EXPENSE_SOURCE = "EXPENSE_SOURCE",
}

export const START_TIME_HOUR = 10;
export const END_TIME_EXTENSION_HOURS = 4;

export const DATE_TIME_FORMAT = "DD-MM-YYYY / hh:mm A";

export const API_DATE_TIME_FORMAT = "YYYY-MM-DD HH:mm:ss";

export const ENV_CONFIG = {
  BACKEND_BASE_URL: process.env.REACT_APP_BACKEND_BASE_URL,
};

export const contentHeight = window.innerHeight - 209;
